export default class MiniCart {

	constructor() {
		document.addEventListener('DOMContentLoaded', () => {
			this.registerHandlers();
		}, false);
	}

	registerHandlers() {
		jQuery('.gumnut-shopping-cart').on('click', function (e) {
			e.preventDefault();

			jQuery('.mini-side-cart').addClass('show');

			jQuery('.mini-side-cart + .overlay').addClass('show');
		});

		jQuery('.close-side-cart, .mini-side-cart + .overlay').on('click', function (e) {
			e.preventDefault();

			jQuery('.mini-side-cart').removeClass('show');

			jQuery('.mini-side-cart + .overlay').removeClass('show');
		});
	}
}
